import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";
import trackingObject from "../tracking-meta";

// let enableScrollGA = false;

export const GAfirePageView = () => {
	// const [enableScrollGA, setEnableScrollGA] = useState(false);
	//const location = useLocation();
	//const [GAinitialized, initGA] = useState(false);
/*
	useEffect(() => {
		ReactGA.initialize("UA-39500825-5", {
			titleCase: false
		});
		initGA(true);
	}, []);
/*


	/*
	useEffect(() => {

		// enableScrollGA = false;

		if (GAinitialized) {

			ReactGA.set({
				location: window.location.href
			});

			ReactGA.pageview(window.location.pathname);
		}
	}, [GAinitialized, location]);
	*/
};

export const GAfireEvent = (trackingID, overrides = false) => {
	const trackingEvent = trackingObject[trackingID];

	// console.log(trackingID, {trackingEvent});

	if (overrides) {
		// overrides are meant to override the tracking object's pre-set values
		// this is typically required when tracking values are determined by the user
		// as in the case of search text input or category selection
		trackingEvent.category = overrides.category || trackingEvent.category;
		trackingEvent.action = overrides.action || trackingEvent.action;
		trackingEvent.label = overrides.label || trackingEvent.label;
	}

	// if (enableScrollGA) {
		/*
		ReactGA.event({
			category: trackingEvent.category,
			action: trackingEvent.action,
			label: trackingEvent.label
		})
		*/
	// }
};
